// TODO: check env
export const marker = (value) => ({
  'data-cy': value,
});
